import React, { ReactElement } from "react";
import Layout from '../../components/layout';
import ProductDetails from "../../components/products/details/ProductDetails";

const ProductDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <ProductDetails />
    </Layout>
  );
};

export default ProductDetailsPage;
